import { Loader2 } from 'lucide-react';

export default function PageLoadingFallback() {
  return (
    <div className="flex min-h-[40vh] flex-1 items-center justify-center bg-slate-50/80">
      <div className="flex flex-col items-center gap-3 text-slate-500">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-500" aria-hidden />
        <span className="text-sm font-medium">Loading…</span>
      </div>
    </div>
  );
}
